import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_95: FaireProductEntity = {
  token: "catalog_prod_prod-95",
  type: "product",
  name: "Storage Container",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 100.46,
  msrpDollars: 251.15,
  sku: "CA0095",
  caseSize: 2,
  material: "Ceramic",
  collectionToken: "col_camp",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 328,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
